import React from 'react';

import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  className?: string;
  onContactSalesClick?: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ className = '', onContactSalesClick }) => {
  return (
    <section className={`py-16 bg-gradient-to-br from-primary via-secondary to-brand-teal relative overflow-hidden ${className}`}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-accent rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-conversion rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm rounded-full px-6 py-3 border border-white/30">
            <Icon name="RocketLaunchIcon" size={24} variant="solid" className="text-white" />
            <span className="font-body text-base font-medium text-white">Start Your Transformation Today</span>
          </div>

          {/* Visual Section Separator */}
         

          {/* Heading */}
          <h2 className="font-display font-bold text-3xl lg:text-5xl text-white leading-tight">
            Ready to Transform Your Customer Engagement?
          </h2>

          {/* Description */}
          <p className="font-body text-xl text-white/90 leading-relaxed max-w-2xl mx-auto">Join 100+ enterprise leaders who have already transformed their customer experience with UnifyMax's AI-powered platform.

          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <button
              onClick={onContactSalesClick}
              className="inline-flex items-center justify-center space-x-2 px-10 py-5 bg-conversion text-conversion-foreground rounded-lg font-cta text-lg font-semibold hover:shadow-cta transition-all duration-300 transform hover:scale-105">

              <Icon name="ChatBubbleLeftRightIcon" size={24} variant="solid" />
              <span>Contact Sales</span>
            </button>
          </div>
        </div>
      </div>
    </section>);

};

export default CTASection;